import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import 'jquery-form';
import 'jquery-validation';
import '../../assets/scripts/bootstrap-modal';
import '../../assets/scripts/jquery-validation.init';
import * as helper from '../global/helper';
import swal from 'sweetalert2';
import { addPayoutCategory } from '../api/subAgencyAPI';
import { addIncentiveCategory } from '../api/agentAPI';

const AddPayoutCategory = (props) => {

    const [name, setName] = useState('');

    useEffect(() => {
        let ignore = false;
        if (!ignore) {
            $('#add-payoutCategory-modal').on('hidden.bs.modal', function () {
                $('.modal').hasClass('show') && $('body').addClass('modal-open');
                $(props.from).removeClass('modal-blur');
            });
        }
        return () => {
          ignore = true;
        };
    }, []);

    const onClose = () => {
        $(props.from).removeClass('modal-blur');
    }

    const addpayoutCategory = async (e) => {
        e.preventDefault();

        var form = $('#add-payoutCategory-form');

        form.validate({
            rules: {
                name: {
                    required: true,
                }
            },
        });

        if(!form.valid()) {
            return;
        }

        try {
            helper.StartProcessing($('#save-payoutCategory'));
            
            const ID =  props.action == 'a' ? await addIncentiveCategory(name) :await addPayoutCategory(name);
            props.addedPayoutCategoryId(ID);

            
            $('#add-payoutCategory-modal').modal('hide');
            swal.fire({
                toast               : true,
                icon                : 'success',
                titleText           : `Payout Category Added successfully!`,
                position            : 'bottom-end',
                showConfirmButton   : false,
                timer               : 1500,
                animation           : false,
                customClass         : {
                    popup: 'margin-20',
                },
            });
            helper.StopProcessing($('#save-payoutCategory'));

        } catch (err) {
            swal.fire({
              icon              : 'error',
              titleText         : 'Error!',
              text              : err.message,
              buttonsStyling    : false,
              confirmButtonClass: 'btn btn-brand',
            });
            helper.StopProcessing($('#save-payoutCategory'));
            return;
        }
    };

    return (
        <div
            className="modal fade"
            id="add-payoutCategory-modal"
            tabIndex="-1"
            role="dialog"
            aria-hidden="true">
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            Add Pay Out Category
                        </h5>
                        <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            onClick={onClose}
                            aria-label="Close">
                        </button>
                    </div>
                    <div className="modal-body">
                        <form id="add-payoutCategory-form" onSubmit={addpayoutCategory}>
                            <div className="row">
                                <div className="col-12">
                                    <input
                                        id="name"
                                        value={name || ''}
                                        name="name"
                                        placeholder="Category Name"
                                        className="form-control margin-b10"
                                        type="text"
                                        onChange={({ target: { value } }) => 
                                            setName(helper.capitalize(value))}
                                        />  
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            onClick={onClose}
                            className="btn btn-secondary margin-0 margin-r5"
                            data-dismiss="modal">   
                            Close
                        </button>
                        <button
                            id="save-payoutCategory"
                            onClick={addpayoutCategory}
                            type="button"
                            className="btn btn-brand margin-0">   
                            Save
                        </button>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default AddPayoutCategory;
